var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 293,
    viewBox: "0 0 295 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.629 63.8301C177.629 63.8301 83.1393 9.54009 33.2893 54.4401C31.7493 56.3501 31.5493 59.0801 32.9093 61.1901C33.4093 61.9901 45.7893 81.0501 75.3793 81.0501C90.1593 81.0501 101.919 73.9801 113.279 67.1201C124.269 60.5001 134.609 54.2401 147.439 54.2401C158.609 54.2401 168.039 58.6201 177.639 63.8301",
    fill: "#A8A9CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2891 54.44C61.3991 19.84 103.019 0 147.429 0C191.839 0 233.409 19.84 261.519 54.44C263.199 56.51 263.239 59.46 261.619 61.59C261.079 62.29 247.879 79.24 219.449 79.24C205.289 79.24 193.609 72.73 182.369 66.43C180.779 65.55 179.199 64.67 177.629 63.82C177.629 63.82 83.1391 9.52999 33.2891 54.43",
    fill: "#6B47F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.009 94.05C284.129 91.76 281.859 90.23 279.359 90.34C278.419 90.37 255.719 91.56 240.919 117.19C233.529 129.99 233.769 143.71 234.039 156.98C234.279 169.81 234.519 181.89 228.109 193C222.529 202.67 214.019 208.66 204.709 214.36C204.789 214.31 298.969 159.65 284.999 94.05",
    fill: "#A8A9CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.009 94.05C300.919 135.7 297.289 181.66 275.089 220.12C252.909 258.54 214.919 284.66 170.899 291.7C168.269 292.12 165.689 290.68 164.649 288.21C164.319 287.39 156.229 267.49 170.449 242.86C177.529 230.59 188.999 223.74 200.079 217.15C201.639 216.21 203.189 215.28 204.719 214.35C204.719 214.35 298.989 159.66 285.019 94.04",
    fill: "#6B47F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.909 242.3C118.519 229.5 106.519 222.85 94.8894 216.45C83.6594 210.24 73.0694 204.41 66.6594 193.31C61.0694 183.64 60.1494 173.28 59.8594 162.37C59.8594 162.4 60.0894 271.35 123.899 292.06C126.329 292.44 128.789 291.24 129.939 289.02C130.389 288.19 140.699 267.94 125.909 242.31",
    fill: "#A8A9CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.899 292.06C79.8794 285.01 41.8894 258.89 19.6794 220.43C-2.50064 182.01 -6.12066 136.05 9.77934 94.4001C10.7293 91.9101 13.2694 90.4001 15.9194 90.7301C16.7994 90.8501 38.0693 93.8001 52.2893 118.42C59.3693 130.69 59.5794 144.05 59.7394 156.94C59.7694 158.76 59.7993 160.56 59.8493 162.35C59.8493 162.35 60.0793 271.33 123.889 292.04",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.09d17035ce76c186bd0f0c6ac52efd1b.svg";
export { ForwardRef as ReactComponent };